import useMutationApi from 'src/api/useMutationApi';

interface Body {
  audio: File; // File to be uploaded
}

interface TranscribeResponse {
  text: string; // Transcribed text
}

const useTranscribe = (onSuccess?: (response: TranscribeResponse) => void) => {
  return useMutationApi<Body, TranscribeResponse>({
    endpoint: 'voice/transcribe',
    method: 'POST',
    options: {
      onSuccess: (response) => {
        console.log('[useTranscribe] Success:', response.data);
        onSuccess?.(response.data);
      },
      onError: (error) => {
        console.error('[useTranscribe] Error:', error);
      },
    },
    transformRequest: (body: Body) => {
      console.log('[useTranscribe] Transforming request - audio file:', {
        name: body.audio.name,
        size: body.audio.size,
        type: body.audio.type,
      });
      const formData = new FormData();
      formData.append('audio', body.audio);
      console.log('[useTranscribe] FormData created');
      return formData;
    },
    showSuccessToast: false,
  });
};

export default useTranscribe;
